// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M18.2994 3.4428L11.9996 0.922852L5.69969 3.4428L6.44247 5.29975L6.99956 5.07692V9.99988H4.99956V11.9999H6.90609C6.74214 13.9053 6.38542 15.9379 6.02101 17.6689C5.77454 18.8396 5.52796 19.8568 5.34314 20.5806C5.25078 20.9424 5.17398 21.2303 5.12052 21.427C5.09379 21.5253 5.0729 21.6008 5.05882 21.6513L5.04295 21.7078L5.03908 21.7215L5.03801 21.7253L4.67383 22.9999H10.2803L11.2803 18.9999H12.7188L13.7188 22.9999H19.3253L18.9609 21.7246L18.96 21.7215L18.9562 21.7078L18.9403 21.6513C18.9262 21.6008 18.9053 21.5253 18.8786 21.427C18.8251 21.2303 18.7483 20.9424 18.656 20.5806C18.4712 19.8568 18.2246 18.8396 17.9781 17.6689C17.6137 15.9379 17.257 13.9053 17.093 11.9999H18.9996V9.99988H16.9996V5.07692L17.5566 5.29975L18.2994 3.4428ZM13.0039 5.99805V8.00195H11V5.99805H13.0039Z"}}]};

const Lighthouse1FilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'lighthouse-1-filled',
    ref,
    icon: element,
  },
));

Lighthouse1FilledIcon.displayName = 'Lighthouse1FilledIcon';

export default Lighthouse1FilledIcon;
